import { Component } from "react";
import { withLocation } from "./withLocation";
import { logAnalytics } from "../../../Firebase/firebase_init";
import * as Sentry from "@sentry/react";

class ErrorHandle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
        };
    }

    // Log catched errors
    componentDidCatch(error, errorInfo) {
        Sentry.captureException(error);

        console.error("Error Boundary caught an error:");
        console.error(error);
        console.error(errorInfo);

        logAnalytics("error_caught", {
            message: error?.message || "",
            trace: error?.stack || "",
            stack: errorInfo?.componentStack || "-",
            route: this.props.location,
        });
    }

    render() {
        return this.props.children;
    }
}

export default withLocation(ErrorHandle);
